export const command = {
  name: 'moveCellSelectionDown',
  callback(_ref) {
    let {
      selection
    } = _ref;
    selection.markSource('keyboard');
    selection.transformStart(1, 0);
    selection.markEndSource();
  }
};